export default __webpack_public_path__ + "static/media/multicolor_two.891da55f.jpg";